/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { Field } from 'redux-form';
import { FormCheckboxField } from '../../../../../../../semantic-ui/components/form-checkbox-field';
import { TABLE_SETTINGS_COLUMNS_NAMES } from '../../../../constants';
import { TableComponent } from '../../../../../../../components/table-component';
import { CustomLoader } from '../../../../../../../components/custom-loader';

const CompanyAdminSettingView = ({ companyAdminSettingInfo, isCompanyAdminSettingInfoLoading }) => {
	if (isCompanyAdminSettingInfoLoading || !companyAdminSettingInfo?.data) {
		return <CustomLoader />;
	}

	const { transports, claims, my_transports } = companyAdminSettingInfo.data;

	const tableTransportsRows = [
		{
			id: 'transports',
			label: 'Транспорт моих ТЭО',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(transports)}
					/>
				</div>
			),
		},
		{
			id: 'my_transports',
			label: 'Мой автопарк',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="my_transports"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(my_transports)}
					/>
				</div>
			),
		},
		{
			id: 'claims',
			label: 'Претензии',
			value: (
				<div className="company-settings-form-view__checkbox">
					<Field
						name="claims"
						component={FormCheckboxField}
						toggle
						type="checkbox"
						disabled
						checked={Boolean(claims)}
					/>
				</div>
			),
		},
	];

	return (
		<div>
			<div className="company-settings-form-view__header_text_section">Настройки модулей</div>
			<TableComponent
				columns={TABLE_SETTINGS_COLUMNS_NAMES}
				rows={tableTransportsRows}
				isTableDataLoading={isCompanyAdminSettingInfoLoading}
				isWithoutHeader
				isChildren
				isInfo
				isWithoutTableHeader
			/>
		</div>
	);
};

CompanyAdminSettingView.propTypes = {
	companyAdminSettingInfo: PropTypes.object,
	isCompanyAdminSettingInfoLoading: PropTypes.bool.isRequired,
	formValues: PropTypes.object,
};

export default CompanyAdminSettingView;
